import React from 'react';
import moment from 'moment';

class SMPromotionListView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="site-main">
        <div className="page__even page__padding campaign-list-page__list">
          <div className="container">
            <div className="page-xs12-head">
              <h1 className="page-title">キャンペーン一覧</h1>
              <p className="page-description">スペースマーケットが期間限定で行っているキャンペーン一覧です<br />お得に利用できるスペースを是非探してみてください！</p>
            </div>
            <div className="row">
              {this.props.promotions.map((promotion, index)=>{
                const coupon = promotion.coupon || promotion.point_code;
                if (!coupon) return null;
                const validAt = moment(coupon.valid_at).utc();
                const expiresAt = moment(coupon.expires_at).utc();
                return(
                  <div key={promotion.id} className="col-sm-12 col-md-4 campaign-box">
                    <a href={Routes.promotion_path(promotion)}>
                      <div className="campaign-linkbox is-hover">
                        <img src={promotion.image} alt={promotion.title} />
                        <h3 style={{backgroundColor: promotion.background_color}} className="campaign-subtitle campaign-subtitle__app">{promotion.title}</h3>
                        <p className="top-units__body-term">{moment(validAt).format("YYYY年M月D日")}〜{moment(expiresAt).format("YYYY年M月D日")}</p>
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

}
export default SMPromotionListView;




// WEBPACK FOOTER //
// ./app/javascript/components/promotions/SMPromotionListView.jsx